import { render, staticRenderFns } from "./ProductAttributeTab.vue?vue&type=template&id=abbf0da0&scoped=true"
import script from "./ProductAttributeTab.vue?vue&type=script&lang=ts"
export * from "./ProductAttributeTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbf0da0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abbf0da0')) {
      api.createRecord('abbf0da0', component.options)
    } else {
      api.reload('abbf0da0', component.options)
    }
    module.hot.accept("./ProductAttributeTab.vue?vue&type=template&id=abbf0da0&scoped=true", function () {
      api.rerender('abbf0da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/components/ProductAttributeTab.vue"
export default component.exports